
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";
import CustomTable from "@/components/CustomTable/index.vue";
import moment from "moment";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import { getWorkbenchCoreDataShop } from "@/api/shouyin";
import { Getter } from "vuex-class";

@Component({
  components: { CustomTable, DimensionSelect, SearchPopup },
})
export default class MultiCoreDataDetail extends Vue {
  @Getter multiStoreList!: Array<any>;

  params: Record<string, any> = {};
  tabList = ["销售笔数", "实收金额", "销售金额", "退货金额"];
  dimension = "总览";
  activeTab = 0;
  showTotal = true;
  searchRes = null;

  listData = [
    {
      label: "销售笔数",
      ratio: "totalOrderCountRatio",
      prop: "totalOrderCount",
    },
    {
      label: "实收金额",
      ratio: "totalSaleMoneyRatio",
      prop: "totalSaleMoney",
    },
    {
      label: "销售金额",
      ratio: "totalOrderMoneyRatio",
      prop: "totalOrderMoney",
    },
    {
      label: "退货金额",
      ratio: "totalReturnMoneyRatio",
      prop: "totalReturnMoney",
    },
  ];

  columns = [
    {
      key: "storeName",
      title: "店铺",
      width: 105,
    },
    {
      key: "totalOrderCountRatio",
      title: "占比",
      align: "left",
      dataType: "proportion",
    },
    {
      key: "totalOrderCount",
      title: "销售笔数",
      align: "right",
      width: 90,
      dataType: "amount",
    },
  ];
  tableDataSource = [];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getData() {
    if (!this.params.queryTimeBegin) return;
    const paramsT = {
      ...this.params,
      storeList: this.multiStoreList.map((item) => {
        return { storeId: item };
      }),
    };
    const res = await getWorkbenchCoreDataShop(paramsT, true);
    if (res.code === "000000") {
      this.tableDataSource = (res.data || []).map((item) => {
        return {
          ...item,
          totalOrderCountRatio: Number(
            item.totalOrderCountRatio.replace("%", "") / 100
          ),
          totalReturnMoneyRatio: Number(
            item.totalReturnMoneyRatio.replace("%", "") / 100
          ),
          totalSaleMoneyRatio: Number(
            item.totalSaleMoneyRatio.replace("%", "") / 100
          ),
          totalOrderMoneyRatio: Number(
            item.totalOrderMoneyRatio.replace("%", "") / 100
          ),
        };
      });
      console.log("查询多店核心数据 **", res);
    }
  }

  @Watch("activeTab")
  onChangeTabs() {
    const name = this.tabList[Number(this.activeTab)];
    const item = this.listData.find((item) => item.label === name);
    if (item) {
      this.columns[1].key = item.ratio;
      this.columns[2].key = item.prop;
      this.columns[2].title = name;
    }
  }

  onDimensionConfirm(value: string, orderType: string) {
    this.dimension = value;
    // 设置参数
    this.params = {
      ...this.params,
      orderType: orderType,
    };
  }
  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      ...this.params,
      queryTimeEnd: `${endtime} 23:59:59`,
      queryTimeBegin: `${starttime} 00:00:00`,
    };
  }
  mounted() {
    const pObj = {
      queryTimeEnd: `${moment().format("YYYY-MM-DD")} 23:59:59`,
      queryTimeBegin: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      orderType: "1",
    };

    const queryObj = this.$route.query;

    if (!Object.keys(queryObj).length) {
      this.params = pObj;
      return;
    }

    if (queryObj.isWorkbench !== "1") {
      this.params = pObj;
      return;
    }
    console.log("this.$route.query ** ", queryObj);
    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
      }
    }
    this.params = pObj;
  }
}
